import {
  SpecialRow,
  SpecialWithComedian,
  SpecialWithUnlocked,
} from "@/data/specials";

import { Comedian } from "@/data/comedians";
import { LivestreamAndToken } from "@punchup/data/legacy/livestreaming";
import { ShowInfo } from "@/data/shows";

export enum FeedPostType {
  SPECIAL = "special",
  COMEDIAN = "comedian",
  NEARBY_SHOWS = "nearby_shows",
  SUGGESTED_SPECIAL = "suggested-special",
  SUGGESTED_COMEDIANS_CAROUSEL = "suggested-comedians-carousel",
  CONTINUE_WATCHING_CAROUSEL = "continue-watching-carousel",
  TRENDING_SPECIALS_CAROUSEL = "trending-specials-carousel",
}

export type TaggedComedian = {
  id: string;
  display_name: string;
  slug: string;
  about_img: string | null;
};

export type FeedPost = {
  id: string;
  score: number;
  date: string;
  type: FeedPostType;
  userFollowsComedian?: boolean;
  special?: SpecialRow;
  livestream?: LivestreamAndToken | null;
  comedian?: Comedian;
  trendingSpecials?: SpecialWithUnlocked[];
  taggedComedians?: TaggedComedian[];
  pageTypeLabel?: string;
};

export interface FeedDataResult {
  feedPosts: FeedPost[];
  suggestedComedians: any[];
  filteredComedianDictionary: Record<string, Comedian>;
  shorts?: SpecialWithComedian[];
}

export interface ComedianWithImageUrl extends Comedian {
  imageUrl?: string;
}

export interface ShowsObject extends Omit<ShowInfo, "datetime"> {}

export interface FeedAdCampaignData {
  comedianDisplayName: string | null;
  comedianPageUrl: string;
  locationName: string;
  shows: ShowsObject[];
}

export interface Short extends SpecialWithComedian {}
